<div class="container fill-horizontal">
  <sv-label-column (itemFocusChange)="onCategoryChanged($event)" [items]="categories"
                   class="fill-vertical"></sv-label-column>
  <sv-video-row [items]="videos" [library]="library" class="fill"></sv-video-row>
</div>
